export default "__VITE_ASSET__rPOWqlt0__"